import {useState} from "react";
import {API_SHARE_MARKETPLACE_OFFERS, API_SHARE_MARKETPLACE_OFFERS_RESERVATION} from "../common/api/apiConstants";
import {shareMarketplaceAPI} from "../common/api/shareMarketplaceAPI";
import {createURLQueryFromParams} from "../common/api/apiUtil";
import {useKeycloakFunctions} from "./useKeycloakFunctions";

export const useMarketplaceOfferReservation = () => {

    const {initialized, authenticated} = useKeycloakFunctions();

    const [offerReservation, setOfferReservation] = useState(undefined);
    const [loadingOfferReservation, setLoadingOfferReservation] = useState(false);
    const [errorOfferReservation, setErrorOfferReservation] = useState(null);

    const reserveOffer = (locale, offerId, buyerId) => {

        if (offerId && initialized && authenticated) {
            setLoadingOfferReservation(true);

            let params = {};
            params.locale = locale || "en_GB";

            let body = { buyer_hapimag_member_id: buyerId };

            shareMarketplaceAPI.post(API_SHARE_MARKETPLACE_OFFERS
                + "/" + offerId + API_SHARE_MARKETPLACE_OFFERS_RESERVATION
                + createURLQueryFromParams(params), body)
                .then(res => res.data)
                .then(response => {
                    setLoadingOfferReservation(false);
                    if (response) {
                        setOfferReservation(response);
                    }
                })
                .catch(err => {
                    setLoadingOfferReservation(false);
                    setErrorOfferReservation(err);
                });
        }
    };

    return {
        reserveOffer,
        offerReservation,
        loadingOfferReservation,
        errorOfferReservation,
        setErrorOfferReservation
    };
};
